export default __webpack_public_path__ + "static/media/6.5456e902.png";